import { createSlice } from "@reduxjs/toolkit";
import { getUserPlanPurchases } from "./thunk";

export interface IState {
  userPlanPurchases: any;
  isUserPlanPurchaseLoading: boolean;
  isUserPlanPurchaseSuccess: boolean;

  error: any;
}

export const initialState: IState = {
  userPlanPurchases: null,
  isUserPlanPurchaseLoading: false,
  isUserPlanPurchaseSuccess: false,

  error: {},
};

const UserPlanPurchaseSlice = createSlice({
  name: "UserPlanPurchase",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //getUserPlanPurchases
    builder.addCase(getUserPlanPurchases.pending, (state: IState, action: any) => {
      state.isUserPlanPurchaseLoading = true;
    });
    builder.addCase(getUserPlanPurchases.fulfilled, (state: IState, action: any) => {
      state.userPlanPurchases = action.payload.data;
      state.isUserPlanPurchaseSuccess = true;
      state.isUserPlanPurchaseLoading = false;
    });
    builder.addCase(getUserPlanPurchases.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isUserPlanPurchaseSuccess = false;
      state.isUserPlanPurchaseLoading = false;
    });
  },
});

export default UserPlanPurchaseSlice.reducer;